export class ProjectAndTaskCreationRequestModel {
    constructor() {
        this.projectName = '';
        this.projectDescription = '';
        this.taskName = '';
        this.taskDescription = '';
    }
}
export default class ProjectAndTaskCreationRequest extends ProjectAndTaskCreationRequestModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
